module.exports = __webpack_public_path__ + "static/media/sf_restaurant_7.fd9aa19e.jpg";